{
  "errors": {
    "400": "Ha ocurrido un error en la solicitud.",
    "401": "Tu sesión ha caducado o no has iniciado sesión. Por favor, vuelve a iniciar sesión para continuar.",
    "402": "No se puede completar esta operación porque requiere un pago. Por favor, actualiza tu suscripción o contacta con soporte.",
    "403": "No tienes permiso para realizar esta acción. Por favor, cierra sesión y vuelve a iniciar sesión. Si el problema persiste, contacta con soporte.",
    "404": "Lo sentimos, no hemos podido encontrar el recurso solicitado.",
    "408": "La conexión está tardando demasiado. Por favor, verifica tu conexión a internet e inténtalo nuevamente.",
    "409": "Ha ocurrido un conflicto con la información existente. Por favor, actualiza la página y vuelve a intentarlo.",
    "500": "Algo ha ido mal en el servidor, vuelve a intentarlo más tarde. Si el problema persiste, contacta con soporte.",
    "503": "El servicio no está disponible en este momento. Estamos trabajando para solucionarlo, por favor, inténtalo más tarde."
  }
}
